import { API_END_POINTS } from '@/shared/api/end-points'
import { methods } from '@/shared/api/constants'
import { SignupDto } from '../../lib'
import { legacyAuthRequest } from './legacy-auth-request'

const signup = async (params: SignupDto) => {
  return await legacyAuthRequest<string>(API_END_POINTS.auth.signup, {
    method: methods.post,
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export default signup
